export default __webpack_public_path__ + "static/media/health_savings_account_dark.6d015717.png";